import { ReportHandler, Metric } from 'web-vitals';
import { logger } from './logging';

const reportWebVitals = (onPerfEntry?: ReportHandler) => {
  const handler: ReportHandler = (metric: Metric) => {
    if (onPerfEntry) {
      onPerfEntry(metric);
    }

    if (metric.name === 'CLS' && metric.value > 0.25) {
      logger.warning(`Poor ${metric.name} web vital`, undefined, {
        sourceFile: 'reportWebVitals.ts',
        sourceClass: 'reportWebVitals',
        sourceLayer: 'Utils',
        metric: metric.name,
        value: metric.value,
      });
    }
  };

  import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
    getCLS(handler);
    getFID(handler);
    getFCP(handler);
    getLCP(handler);
    getTTFB(handler);
  });
};

export default reportWebVitals;
